import React, { useContext, useCallback } from 'react'
import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import { withStyles } from '@material-ui/core/styles'
import styles from './styles'
import { FormContext } from '../index'

const ColorCircularProgress = withStyles({
  root: {
    color: 'white',
  },
})(CircularProgress)

const StyledButton = withStyles(styles)(Button)

const SubmitButton = props => {
  const form = useContext(FormContext)

  const onClick = useCallback(
    e => {
      props.onClick && props.onClick(e, form)
    },
    [form],
  )

  return (
    <StyledButton
      {...props}
      onClick={onClick}
      variant="contained"
      size={'large'}
    >
      {props.formSubmitting ? <ColorCircularProgress size={25} /> : props.value}
      {props.children}
    </StyledButton>
  )
}
export default SubmitButton



// WEBPACK FOOTER //
// ./src/Components/Form/Button/index.js